export default __webpack_public_path__ + "1b78fadc95992f0d306369c621ea28ea.svg";